<template>
  <div
    class="grid w-full min-[900px]:grid-cols-[repeat(5,20vw)] min-[900px]:grid-rows-[repeat(2_20vw)]"
  >
    <div
      class="col-span-3 col-start-1 row-span-2 row-start-1 grid grid-cols-3 bg-avu-pink px-[26px] py-[60px] font-avuText text-avu-black min-[900px]:py-[95px] min-[900px]:pb-[112px] min-[900px]:pl-[61px] min-[900px]:pr-[76px]"
    >
      <h1 class="col-span-2 w-max text-[66px]/[77px] xl:col-span-1">News</h1>

      <div
        class="col-span-3 col-start-1 mt-[17px] flex flex-col items-center xl:col-span-2 xl:col-start-2"
      >
        <NuxtLink
          :to="`/news/${item.slug}`"
          v-for="item in news"
          :key="item.date"
          class="flex flex-col gap-1 border-b border-avu-black py-5 transition duration-300 ease-in-out last:border-b-0 hover:text-avu-blue"
        >
          <span class="text-sm/[22px]"
            >{{ dayjs(item.date).format("MMM DD, YYYY") }}
          </span>
          <span class="line-clamp-2 text-ellipsis text-xl">{{
            item.name
          }}</span>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
  import dayjs from "dayjs";
  const props = defineProps(["news"]);
</script>
